import React from 'react';
import {
  LocalShipping as ShippingIcon,
  Inventory as InventoryIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Build as BuildIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  LocalShippingOutlined as LocalShippingOutlinedIcon,
  Inventory2 as Inventory2Icon  
} from '@mui/icons-material';
import { PurchaseOrderItemStatus, PurchaseOrderItemStatusColors } from '@domain/purchasing';
import { KanbanColumn } from '../types/types';

export const columns: KanbanColumn[] = [
  {
    id: PurchaseOrderItemStatus.PLANNED,
    title: 'Planned',
    color: PurchaseOrderItemStatusColors[PurchaseOrderItemStatus.PLANNED],
    icon: React.createElement(CheckCircleOutlineIcon)
  },
  {
    id: PurchaseOrderItemStatus.IN_PRODUCTION,
    title: 'Production',
    color: PurchaseOrderItemStatusColors[PurchaseOrderItemStatus.IN_PRODUCTION],
    icon: React.createElement(BuildIcon)
  },
  {
    id: PurchaseOrderItemStatus.IN_TRANSIT,
    title: 'In Transit',
    color: PurchaseOrderItemStatusColors[PurchaseOrderItemStatus.IN_TRANSIT],
    icon: React.createElement(LocalShippingOutlinedIcon)
  },
  {
    id: PurchaseOrderItemStatus.IN_DELIVERY,
    title: 'Delivery',
    color: PurchaseOrderItemStatusColors[PurchaseOrderItemStatus.IN_DELIVERY],
    icon: React.createElement(ShippingIcon)
  },

  {
    id: PurchaseOrderItemStatus.AVAILABLE,
    title: 'Available',
    subtitle: 'Items that are available in the warehouse',
    color: PurchaseOrderItemStatusColors[PurchaseOrderItemStatus.AVAILABLE],
    icon: React.createElement(Inventory2Icon)
  }
]; 